import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Checkbox, Grid, IconButton, Select, TextField, Tooltip, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TableChartIcon from '@mui/icons-material/TableChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import CategoryIcon from '@mui/icons-material/Category';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CompareIcon from '@mui/icons-material/Compare';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import StarIcon from '@mui/icons-material/Star';
import { withStyles } from '@material-ui/styles';
import { WIDGETS } from '../../../util/constants';

const styles = (theme) => ({
  widgetButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "15vw",
    height: "100px"
  }

});

const defaultOptions = [
  {
    type: WIDGETS.TOTAL_INSIGHTS,
    title: "Total Insights",
    icon: <Typography style={{ fontSize: "40px"}} >123</Typography>,
    size: {
      width: 2,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.TOTAL_CLASSES,
    title: "Total Classes",
    icon: <Typography style={{ fontSize: "40px"}} >123</Typography>,
    size: {
      width: 2,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.TOTAL_DEVICES,
    title: "Total Devices",
    icon: <Typography style={{ fontSize: "40px"}} >123</Typography>,
    size: {
      width: 2,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHT_BY_HOUR_OF_DAY,
    title: "Insights by Hour of Day",
    icon: <ScheduleIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.DEVICE_HOURS_SINCE_TABLE,
    title: "Last Device Communication Table",
    icon: <TableChartIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.DEVICE_HOURS_SINCE_GRAPH,
    title: "Last Device Communication Graph",
    icon: <BarChartIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.DEVICE_HEATMAP,
    title: "Device Heatmap",
    icon: <LocalFireDepartmentIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHTS_BY_CLASS,
    title: "Insights by Class",
    icon: <CategoryIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHTS_OVER_2_WEEKS,
    title: "Insights over 2 Weeks",
    icon: <CalendarTodayIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHTS_VS_IMAGES,
    title: "Insight vs Image Counts",
    icon: <CompareIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHT_COMMS_SOURCE,
    title: "Insights by Comms Source",
    icon: <DonutSmallIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 2,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHT_DELAY,
    title: "Insight Delay",
    icon: <CandlestickChartIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 4,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  },
  {
    type: WIDGETS.INSIGHT_STATUSES,
    title: "Insight Statuses",
    icon: <StarIcon style={{ fontSize: "40px", marginTop: "8px", marginBottom: 0}} />,
    size: {
      width: 2,
      height: 2
    },
    position: {
      x: 0,
      y: 0
    },
    selected: false
  }
]


function AddWidgetModal(props) {
  const { classes, addAction } = props;

  const [open, setOpen] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);
  const [widgetOptions, setWidgetOptions] = useState([...defaultOptions]);

  const handleSave = () => {
    addAction(widgetOptions.filter((option) => option.selected)[0]);
    setWidgetOptions([...defaultOptions]);
    setHasSelected(false);
    setOpen(false);

  }

  const handleWidgetClick = (index) => {
    const newOptions = [...widgetOptions];
    for (let i = 0; i < newOptions.length; i += 1) {
      if (i === index) {
        newOptions[i].selected = true;
      } else {
        newOptions[i].selected = false;
      }
    }
    setHasSelected(true);
    setWidgetOptions(newOptions);
  }

  return (
    <>
      <Tooltip title="Add Widget">
        <IconButton
          onClick={() => {
            setOpen(true);
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          Add Widget
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {widgetOptions.map((option, index) => (
              <Grid item xs={6} sm={3} key={index}>
                <Button
                  variant={option.selected ? 'contained' : 'outlined'}
                  color={option.selected ? 'primary' : 'inherit'}
                  fullWidth
                  onClick={() => handleWidgetClick(index)}
                >
                  <div className={classes.widgetButton}>
                    {option.icon}
                    <Typography style={{ fontSize: '12px' }}>{option.title}</Typography>
                  </div>
                </Button>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSave}
            variant="contained"
            disabled={!hasSelected}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default withStyles(styles)(AddWidgetModal);